import { getFullOrderOptions, getInDraftOrderForUserOptions, type OrderViewModel } from '@generated';
import type { QueryKey } from '@tanstack/react-query';

export function getInvalidateOrderQueryKeys(order: OrderViewModel): QueryKey[] {
	return [getFullOrderOptions(order.id).queryKey, getInDraftOrderForUserOptions(order.id, order.createdById).queryKey];
}
